import React from "react";

const Esperar = ({ titulo, imagen }) => {
  return (
    <div className="w-full bg-[#E8F2F4] flex justify-center py-20">
      <div className="grid grid-cols-12 items-center">
        <div className="col-span-6 flex justify-end px-10">
          <h2 className="text-5xl font-extrabold text-[#02357c] mb-4 leading-snug w-[40%] text-justify mr-10" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.4)' }}>
            {titulo}
          </h2>
        </div>
        <div className="col-span-6 flex justify-start">
          <img src={imagen} alt="Qué esperar" className="w-full max-w-[600px] h-auto" />
        </div>
      </div>
    </div>
  );
};

export default Esperar;